NewCourseController.$inject = ['CourseService', 'AppService', '$uibModal', '$transitions', '$scope']

export default function NewCourseController(CourseService, AppService, $uibModal, $transitions, $scope) {
  var vm = this

  function saveSelection() {
    if (window.getSelection) {
      sel = window.getSelection()
      if (sel.getRangeAt && sel.rangeCount) {
        var ranges = []
        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
          ranges.push(sel.getRangeAt(i))
        }
        return ranges
      }
    } else if (document.selection && document.selection.createRange) {
      return document.selection.createRange()
    }
    return null
  }

  vm.course = CourseService.initCourse()

  vm.insertLink = function() {
    AppService.savedSel = saveSelection()

    $uibModal.open({
      controller: 'ModalLinkController',
      controllerAs: 'modalLink',
      template: require('../../app/link-modal-new.html')
    }).result.then(angular.noop, angular.noop)
  }
  vm.setPromoted = function() {
    vm.course.isPromoted = !vm.course.isPromoted
  }
  vm.setPublished = function() {
    vm.course.isPublished = !vm.course.isPublished
  }
  vm.toggleAddLesson = function() {
    vm.addLesson = !vm.addLesson
  }
  $transitions.onBefore({}, () => {
    if (!vm.cancelled && !$scope.pristine.isPristine()) return CourseService.postCourse(vm.course)
  }, {invokeLimit: 1})
}